import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {TableActionMenu} from "~/ui/ActionMenu/ActionMenu";

import { Button, Divider, HStack, Tooltip, } from "~/native-ui"
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';
import identify from '~/identify';

class TableActions extends Component {
	static propTypes = {
        modelId: PropTypes.string.isRequired,
        onAdd: PropTypes.func.isRequired,
        canCreate: PropTypes.bool.isRequired,
		addText: PropTypes.string.isRequired,
        createTooltip: PropTypes.string,
		isSmallScreen: PropTypes.bool,
		divider: PropTypes.bool,
	};
	

	renderActions() {
		// const actions = this.props.canCreate ? this.dropdownActions : undefined;

		return (
			<TableActionMenu
				modelId={this.props.modelId}
				standAlonePrimaryAction={!this.props.isSmallScreen}
				dropdownMode={this.props.isSmallScreen}
				showStartDivider={!this.props.isSmallScreen && this.props.divider}
				actions={this.dropdownActions}
			/>
		);
	}


	onAdd = (...args) => {
		return this.props.onAdd?.(...args);
	}

	dropdownActions = [{
		action: this.onAdd,
		caption: this.props.addText,
		group: identify.PRIMARY_ACTION_GROUP,
		disabled: false,
		isActive: false,
		icon: "add",
		variant: "solid",
		hasPermission: this.props.canCreate,
		order: -1000,
		showLabel: true,
		value: ""
	}]

	render() {
		return this.renderActions();
	}
}

export default withResponsiveFlags(TableActions, {
	includeKeys: ['isSmallScreen']
})